import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { selectStore } from "../../store/selector";
import { Button, Card, Col, DatePicker, Form, Input, message, Modal, Row, Select, Table, TimePicker } from "antd";
import dayjs from "dayjs";
import locale from "antd/es/date-picker/locale/ru_RU";
import { MyBreadcrumb, MyButton, MyModalForm, MyText, OuterTabs } from "../../components";
import { EditOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate, useSearchParams } from "react-router-dom";
import { ModalBodyInline, ModalBodyItem, ModalBodyItemLeft, ModalBodyItemText, ModalTitle } from "./index.style";
import TextArea from "antd/lib/input/TextArea";
import { deletePsychologistSchedule, getPsychologistSchedule, getPsychologistWorkFilter, postPsychologistSchedule, postPsychologistScheduleReset, putPsychologistSchedule, putPsychologistScheduleReset } from "../../store/pages/psychologist/actions";
import { SCHEDULE_WEEKS } from "../../constants/main";
import { QUERY_PARAMS, ROUTE_PATH, SCHEDULE_TYPES } from "../../constants";
import { WorkSubtabView } from "./WorkSubtab";


// const DATEFORMATBACKEND = "YYYY-MM-DD HH:mm:00"
const TIME = "HH:mm"
const rules = [
  {
    required: true,
    message: 'Введите!',
  },
]
const FORM = {
  ID: "id",
  TYPE: 'type',
  START_TIME: "start_time",
  END_TIME: "end_time",
  BREAK_START_TIME: "break_start_time",
  BREAK_END_TIME: "break_end_time",
  NOTE: "note",
  WEEKDAYS: "weekdays"
}
export const PsychologistRoom = () => {
  const { t } = useTranslation("common")
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const typeQuery = searchParams.get(QUERY_PARAMS.type);
  const navigate = useNavigate();
  const {
    psychologist: {
      psychologistSchedule,
      postPsychologistSchedule: postPsychologistScheduleState,
      editPsychologistSchedule,
      deletePsychologistSchedule: deletePsychologistScheduleState,
      psychologistWorkFilter,
    }
  }: RootState = useSelector(selectStore)

  const [workScheduleForm] = Form.useForm()
  const [type, setType] = useState<string>(typeQuery ? typeQuery : "schedule");


  const [modalAddSchedule, setModalAddSchedule] = useState<boolean>(false)
  const [modalDeleteSchedule, setModalDeleteSchedule] = useState<boolean>(false)

  const [modalDeleteInfo, setModalDeleteInfo] = useState<any>(null)
  const [tabsList, setTabsList] = useState<any[]>([])
  const isTabList = () =>{
    if(type == "schedule" || type == "questionnaire")return false;
    return true
  }
  const questionnaireTabItems = [
    {
      key: 'questionnaire',
      label: 'Анкетирование',
      children: (
        <Row>
          <Col span={24}>
            <Card>
              {/* {appearRender()} */}
            </Card>
          </Col>
        </Row>
      ),
    },
  ]

  const scheduleColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'index',
      width: 60,
      render: (item: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      title: 'Вид деятельности',
      key: 'Вид деятельности',
      dataIndex: 'type',
      width: 200,
      ellipsis: true
    },
    {
      title: 'Время начала',
      key: 'Время начала',
      dataIndex: 'start_time',
    },
    {
      title: 'Время окончания',
      key: 'Время окончания',
      dataIndex: 'end_time',
    },
    {
      title: 'Перерыв (начало)',
      key: 'Перерыв (начало)',
      dataIndex: 'break_start_time',
    },
    {
      title: 'Перерыв (окончание)',
      key: 'Перерыв (окончание)',
      dataIndex: 'break_end_time',
    },
    {
      title: 'Рабочие дни',
      key: 'Рабочие дни',
      dataIndex: 'weekdays',
      render: (item: any, record: any, index: any) => {
        return record.weekdays.map((el: any, indexEl: any) => {
          let last = indexEl == record.weekdays.length - 1 ? " " : ", ";
          return SCHEDULE_WEEKS().find((elFind: any) => el === elFind.value)?.label + last;
        })
      },
    },
    {
      title: 'Примечание',
      key: 'Примечание',
      dataIndex: 'note',
      ellipsis: true,
      width: 300
    },
    {
      title: 'Действие',
      key: 'Действие',
      dataIndex: 'action',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row gutter={6} style={{ width: '100%' }} justify='center'>
            <Col>
              <MyButton icon={<EyeOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => {
                  goToView(record.id)
                }} />
              <MyButton icon={<EditOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => {
                  editSchedule(record)
                  setModalAddSchedule(true);
                }} />
              <MyButton icon={<DeleteOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => {
                  setModalDeleteInfo(record.id)
                  setModalDeleteSchedule(true);
                }} />
            </Col>
          </Row>
        )
      },
    }
  ]

  const appearRender = () => {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row justify={'space-between'}>
            <MyText size={24} weight={700} color='var(--c-title-text)'>
              График работы психолога
            </MyText>
            <Col>
              <Button style={{ marginLeft: 16 }} onClick={() => { setModalAddSchedule(true) }}>Добавить</Button>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table locale={{
            triggerDesc: t("triggerDesc"),
            triggerAsc: t("triggerAsc"),
            cancelSort: t("cancelSort"),
            emptyText: () =>
              <Row style={{ padding: 32 }} justify={'center'}>
                {
                  // appeals?.data?.appeals && filterAppearForm.isFieldsTouched() ? "Ничего не найдено" : "Выберите фильтры для просмотра"
                }
              </Row>
          }} columns={scheduleColumn}
            dataSource={psychologistSchedule?.data} loading={psychologistSchedule.loading}
            rowKey={(appearItem) => appearItem.id} pagination={false} />
        </Col>
      </Row>
    )
  }
  const psychologistTabItems = [
    {
      key: 'schedule',
      label: 'График работы психолога',
      children: (
        <Row>
          <Col span={24}>
            <Card>
              {appearRender()}
            </Card>
          </Col>
        </Row>
      ),
    },
  ]

  useEffect(() => {
    if (psychologistWorkFilter.success && psychologistWorkFilter?.data?.work_type) {
      const subTabsType = Object.keys(psychologistWorkFilter?.data?.work_type)?.map((item: any) => {
        const elItem = psychologistWorkFilter?.data?.work_type[item]
        return {
          key: elItem,
          label: elItem,
        }
      })
      setTabsList(subTabsType)
    }
  }, [psychologistWorkFilter])

  useEffect(() => {
    if (editPsychologistSchedule.success || postPsychologistScheduleState.success) {
      dispatch(getPsychologistSchedule())
      dispatch(postPsychologistScheduleReset());
      dispatch(putPsychologistScheduleReset());
      setModalAddSchedule(false);
    }
  }, [editPsychologistSchedule, postPsychologistScheduleState])

  useEffect(() => {
    if (deletePsychologistScheduleState.success) {
      setModalDeleteInfo(null);
      setModalDeleteSchedule(false);
      dispatch(getPsychologistSchedule())
    }
  }, [deletePsychologistScheduleState])

  useEffect(() => {
    dispatch(getPsychologistWorkFilter())
    if (type == 'schedule') {
      dispatch(getPsychologistSchedule())
    }
  }, [])


  const deleteSchedule = () => {
    dispatch(deletePsychologistSchedule(modalDeleteInfo))
  }

  const onCloseModal = () => {
    setModalAddSchedule(false)
    workScheduleForm.resetFields();
  }


  const editSchedule = (data: any) => {
    workScheduleForm.setFieldsValue({
      ...data,
      [FORM.TYPE]: SCHEDULE_TYPES.find((el) => el.name == data[FORM.TYPE])?.id,
      [FORM.START_TIME]: dayjs(dayjs().format("YYYY-MM-DD").toString() + "T" + data[FORM.START_TIME]),
      [FORM.END_TIME]: dayjs(dayjs().format("YYYY-MM-DD").toString() + "T" + data[FORM.END_TIME]),
      [FORM.BREAK_START_TIME]: dayjs(dayjs().format("YYYY-MM-DD").toString() + "T" + data[FORM.BREAK_START_TIME]),
      [FORM.BREAK_END_TIME]: dayjs(dayjs().format("YYYY-MM-DD").toString() + "T" + data[FORM.BREAK_END_TIME])
    });
  }

  const sendNewOrEditSchedule = (values: any) => {
    const data = {
      ...values,
      // type: ,
      [FORM.BREAK_END_TIME]: dayjs(values?.break_end_time).format(TIME),
      [FORM.BREAK_START_TIME]: dayjs(values?.break_start_time).format(TIME),
      [FORM.END_TIME]: dayjs(values?.end_time).format(TIME),
      [FORM.START_TIME]: dayjs(values?.start_time).format(TIME),
    }
    if (data?.id) {
      dispatch(putPsychologistSchedule(data))
    } else {
      dispatch(postPsychologistSchedule(data))
    }
    workScheduleForm.resetFields();
  }

  const handleClickOuterTab = (key: any) => {
    setSearchParams({ [QUERY_PARAMS.type]: key })
    setType(key)
    switch (key) {
      case "schedule":
        dispatch(getPsychologistSchedule())
        break;
    }
  }


  const goToView = (id: string) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.PSYCHOLOGIST_VIEW, { id: id }),
    }
    navigate(path)
  }


  return (
    <>
      <MyBreadcrumb title="Кабинет психолога" />

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
            {/* , ...questionnaireTabItems */}
              <OuterTabs items={[...psychologistTabItems, ...tabsList ]} onChange={(key) => handleClickOuterTab(key)} activeKey={type} />
              {isTabList() && <WorkSubtabView searchParams={searchParams} setSearchParams={setSearchParams} selectedType={type} />}
            </Col>
          </Row>
        </Col>
      </Row>
      <Modal footer={null} onCancel={() => { onCloseModal() }} open={modalAddSchedule}>
        <Row style={{ marginBottom: 12 }}>
          <ModalTitle>Добавления обращения</ModalTitle>
        </Row>
        <Form onFinish={(values) => sendNewOrEditSchedule(values)}
          onReset={() => { onCloseModal() }}
          form={workScheduleForm} layout={"vertical"} >
          <ModalBodyItem style={{ display: 'none' }} name={[FORM.ID]} >
            <Input></Input>
          </ModalBodyItem>
          <ModalBodyItem label={<ModalBodyItemText>Вид деятельности:</ModalBodyItemText>} name={[FORM.TYPE]} rules={rules}>
            <Select
              style={{ width: "100%" }}
              placeholder='Вид деятельности'>
              {
                SCHEDULE_TYPES.map((item: any) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))
              }
            </Select>
          </ModalBodyItem>
          <ModalBodyItem label={<ModalBodyItemText>День недели:</ModalBodyItemText>} name={[FORM.WEEKDAYS]} rules={rules}>
            <Select
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="День недели"
              // onChange={handleChange}
              options={SCHEDULE_WEEKS()}
            />
          </ModalBodyItem>
          <ModalBodyInline>
            <ModalBodyItemLeft label={<ModalBodyItemText>Время начала:</ModalBodyItemText>} name={[FORM.START_TIME]} rules={rules}>
              <TimePicker locale={locale} placeholder="Время начала" format={TIME} style={{ width: "100%" }} />
            </ModalBodyItemLeft>
            <ModalBodyItem label={<ModalBodyItemText>Время окончания:</ModalBodyItemText>} name={[FORM.END_TIME]} rules={rules}>
              <TimePicker locale={locale} placeholder="Время окончания" format={TIME} style={{ width: "100%" }} />
            </ModalBodyItem>
          </ModalBodyInline>
          <ModalBodyInline>
            <ModalBodyItemLeft label={<ModalBodyItemText>Перерыв  начала:</ModalBodyItemText>} name={[FORM.BREAK_START_TIME]} rules={rules}>
              <TimePicker locale={locale} placeholder="Перерыв  начала" format={TIME} style={{ width: "100%" }} />
            </ModalBodyItemLeft>
            <ModalBodyItem label={<ModalBodyItemText>Перерыв  окончания:</ModalBodyItemText>} name={[FORM.BREAK_END_TIME]} rules={rules}>
              <TimePicker locale={locale} placeholder="Перерыв  окончания" format={TIME} style={{ width: "100%" }} />
            </ModalBodyItem>
          </ModalBodyInline>
          <ModalBodyItem label={<ModalBodyItemText>Примечание:</ModalBodyItemText>} name={[FORM.NOTE]} rules={rules}>
            <TextArea rows={4}></TextArea>
          </ModalBodyItem>

          <Form.Item >
            <Row justify={'end'}>
              <Button type="default" htmlType="reset">
                Отмена
              </Button>
              <Button style={{ marginLeft: 16 }} type="primary" htmlType="submit">
                {
                  workScheduleForm?.getFieldValue(FORM.ID) ? "Сохранить" : "Добавить"
                }
              </Button>
            </Row>
          </Form.Item>
        </Form>

      </Modal>

      <Modal open={modalDeleteSchedule} onCancel={() => setModalDeleteSchedule(false)} okText="Удалить" cancelText="Отмена" onOk={() => { deleteSchedule() }}>
        <Row style={{ marginBottom: 12 }}>
          <ModalTitle>Удалить расписание №{modalDeleteInfo}</ModalTitle>
        </Row>
      </Modal>
    </>
  )
}
